/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceVideoConfig
 */
export interface SurfaceVideoConfig {
    /**
     * 
     * @type {string}
     * @memberof SurfaceVideoConfig
     */
    source?: SurfaceVideoConfigSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceVideoConfig
     */
    videoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceVideoConfig
     */
    videoAssetId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceVideoConfig
     */
    posterImageId?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceVideoConfig
     */
    posterImageUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceVideoConfig
     */
    autoplay?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceVideoConfig
     */
    loop?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SurfaceVideoConfig
     */
    maxHeight?: number;
    /**
     * 
     * @type {string}
     * @memberof SurfaceVideoConfig
     */
    aspectRatio?: SurfaceVideoConfigAspectRatioEnum;
}


/**
 * @export
 */
export const SurfaceVideoConfigSourceEnum = {
    UPLOAD: 'UPLOAD',
    YOUTUBE: 'YOUTUBE',
    TWITCH_CLIP: 'TWITCH_CLIP'
} as const;
export type SurfaceVideoConfigSourceEnum = typeof SurfaceVideoConfigSourceEnum[keyof typeof SurfaceVideoConfigSourceEnum];

/**
 * @export
 */
export const SurfaceVideoConfigAspectRatioEnum = {
    _169: '16:9',
    _219: '21:9',
    _43: '4:3',
    _11: '1:1'
} as const;
export type SurfaceVideoConfigAspectRatioEnum = typeof SurfaceVideoConfigAspectRatioEnum[keyof typeof SurfaceVideoConfigAspectRatioEnum];


/**
 * Check if a given object implements the SurfaceVideoConfig interface.
 */
export function instanceOfSurfaceVideoConfig(value: object): value is SurfaceVideoConfig {
    return true;
}

export function SurfaceVideoConfigFromJSON(json: any): SurfaceVideoConfig {
    return SurfaceVideoConfigFromJSONTyped(json, false);
}

export function SurfaceVideoConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceVideoConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'source': json['source'] == null ? undefined : json['source'],
        'videoUrl': json['videoUrl'] == null ? undefined : json['videoUrl'],
        'videoAssetId': json['videoAssetId'] == null ? undefined : json['videoAssetId'],
        'posterImageId': json['posterImageId'] == null ? undefined : json['posterImageId'],
        'posterImageUrl': json['posterImageUrl'] == null ? undefined : json['posterImageUrl'],
        'autoplay': json['autoplay'] == null ? undefined : json['autoplay'],
        'loop': json['loop'] == null ? undefined : json['loop'],
        'maxHeight': json['maxHeight'] == null ? undefined : json['maxHeight'],
        'aspectRatio': json['aspectRatio'] == null ? undefined : json['aspectRatio'],
    };
}

export function SurfaceVideoConfigToJSON(json: any): SurfaceVideoConfig {
    return SurfaceVideoConfigToJSONTyped(json, false);
}

export function SurfaceVideoConfigToJSONTyped(value?: SurfaceVideoConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': value['source'],
        'videoUrl': value['videoUrl'],
        'videoAssetId': value['videoAssetId'],
        'posterImageId': value['posterImageId'],
        'posterImageUrl': value['posterImageUrl'],
        'autoplay': value['autoplay'],
        'loop': value['loop'],
        'maxHeight': value['maxHeight'],
        'aspectRatio': value['aspectRatio'],
    };
}

